
// import React, { useEffect, useRef, useState } from "react";
// import {
//   FiMail,
//   FiPhone,
//   FiClock,
//   FiCheckCircle,
//   FiUploadCloud,
//   FiArrowUpRight,
//   FiFileText,
//   FiLayers,
//   FiGrid,
// } from "react-icons/fi";


// const Contact = () => {
//   const sectionRef = useRef(null);
//   const [visible, setVisible] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     company: "",
//     email: "",
//     phone: "",
//     projectType: "",
//     service: "",
//     divisions: [],
//     message: "",
//     files: [],
//   });

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//         }
//       },
//       { threshold: 0.12 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const projectTypes = [
//     "Commercial",
//     "Residential",
//     "Industrial",
//     "Institutional",
//     "Healthcare",
//     "Hospitality",
//     "Mixed-Use",
//     "Other",
//   ];

//   const services = [
//     "Quantity Takeoff",
//     "Construction Estimating",
//     "Material Takeoff",
//     "Bid Preparation",
//     "Cost Analysis",
//     "Preconstruction Support",
//   ];

//   const divisions = [
//     "01 - General Requirements / GC",
//     "02 - Existing Conditions",
//     "03 - Concrete",
//     "04 - Masonry",
//     "05 - Metals",
//     "07 - Thermal & Moisture Protection",
//     "08 - Openings",
//     "09 - Finishes",
//     "32 - Exterior Improvements",
//   ];

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((previous) => ({
//       ...previous,
//       [name]: value,
//     }));
//   };

//   const handleDivisionChange = (division) => {
//     setFormData((previous) => {
//       const exists = previous.divisions.includes(division);

//       return {
//         ...previous,
//         divisions: exists
//           ? previous.divisions.filter(
//             (item) => item !== division
//           )
//           : [...previous.divisions, division],
//       };
//     });
//   };

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files || []);

//     setFormData((previous) => ({
//       ...previous,
//       files,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     /*
//       Connect this function to your backend,
//       Formspree, EmailJS, Firebase, or API
//       when you are ready for production.
//     */

//     console.log("Estimate Request:", formData);

//     setSubmitted(true);

//     setTimeout(() => {
//       setSubmitted(false);
//     }, 5000);
//   };

//   return (
//     <>
//       <style>{`

//         /* =====================================================
//            CONTACT SECTION
//         ===================================================== */

//         .sg-contact {
//           position: relative;
//           overflow: hidden;

//           padding: 125px 0;

//           background: #ffffff;
//         }

//         .sg-contact-container {
//           position: relative;

//           z-index: 2;

//           width: min(1380px, 92%);

//           margin: auto;
//         }

//         /* =====================================================
//            BLUEPRINT BACKGROUND
//         ===================================================== */

//         .sg-contact-blueprint {
//           position: absolute;

//           right: -180px;
//           bottom: -100px;

//           width: 650px;
//           height: 650px;

//           opacity: 0.32;

//           background-image:
//             linear-gradient(
//               rgba(25, 88, 175, 0.055) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(25, 88, 175, 0.055) 1px,
//               transparent 1px
//             );

//           background-size: 35px 35px;

//           transform: rotate(8deg);

//           pointer-events: none;
//         }

//         /* =====================================================
//            HEADER
//         ===================================================== */

//         .sg-contact-heading {
//           max-width: 780px;

//           margin: 0 auto 65px;

//           text-align: center;

//           opacity: 0;

//           transform: translateY(30px);

//           transition:
//             opacity 0.7s ease,
//             transform 0.7s ease;
//         }

//         .sg-contact-heading.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         .sg-contact-label {
//           display: inline-flex;

//           align-items: center;
//           justify-content: center;

//           gap: 9px;

//           color: #175bc3;

//           font-size: 12px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-contact-label-line {
//           width: 30px;
//           height: 2px;

//           border-radius: 10px;

//           background: #f39818;
//         }

//         .sg-contact-title {
//           margin: 17px 0 18px;

//           color: #10213f;

//           font-size: clamp(40px, 4.4vw, 63px);

//           line-height: 1.03;

//           letter-spacing: -2.6px;

//           font-weight: 800;
//         }

//         .sg-contact-title span {
//           color: #1b60c8;
//         }

//         .sg-contact-intro {
//           max-width: 650px;

//           margin: auto;

//           color: #68768a;

//           font-size: 16px;

//           line-height: 1.75;
//         }

//         /* =====================================================
//            MAIN GRID
//         ===================================================== */

//         .sg-contact-grid {
//           display: grid;

//           grid-template-columns:
//             0.75fr
//             1.25fr;

//           gap: 30px;

//           align-items: stretch;
//         }

//         /* =====================================================
//            LEFT INFORMATION
//         ===================================================== */

//         .sg-contact-info {
//           position: relative;

//           overflow: hidden;

//           padding: 38px;

//           border-radius: 22px;

//           background:
//             linear-gradient(
//               145deg,
//               #102b4d 0%,
//               #174f8d 100%
//             );

//           box-shadow:
//             0 25px 60px rgba(16, 48, 84, 0.17);

//           opacity: 0;

//           transform: translateX(-35px);

//           transition:
//             opacity 0.8s ease,
//             transform 0.8s ease;
//         }

//         .sg-contact-info.visible {
//           opacity: 1;

//           transform: translateX(0);
//         }

//         .sg-contact-info::before {
//           content: "";

//           position: absolute;

//           width: 450px;
//           height: 450px;

//           right: -230px;
//           top: -250px;

//           border: 1px solid rgba(255,255,255,0.09);

//           border-radius: 50%;
//         }

//         .sg-contact-info::after {
//           content: "";

//           position: absolute;

//           width: 300px;
//           height: 300px;

//           right: -130px;
//           top: -170px;

//           border: 1px dashed rgba(255,255,255,0.08);

//           border-radius: 50%;
//         }

//         .sg-contact-info-content {
//           position: relative;

//           z-index: 3;
//         }

//         .sg-contact-info-label {
//           color: #f7a62c;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-contact-info-title {
//           max-width: 430px;

//           margin: 12px 0 17px;

//           color: #ffffff;

//           font-size: 34px;

//           line-height: 1.12;

//           letter-spacing: -1.2px;

//           font-weight: 800;
//         }

//         .sg-contact-info-text {
//           max-width: 430px;

//           margin: 0;

//           color: rgba(255,255,255,0.65);

//           font-size: 12px;

//           line-height: 1.75;
//         }

//         /* =====================================================
//            CONTACT DETAILS
//         ===================================================== */

//         .sg-contact-details {
//           margin-top: 40px;
//         }

//         .sg-contact-detail {
//           display: flex;

//           align-items: center;

//           gap: 13px;

//           padding: 17px 0;

//           border-bottom: 1px solid rgba(255,255,255,0.10);
//         }

//         .sg-contact-detail:last-child {
//           border-bottom: none;
//         }

//         .sg-contact-detail-icon {
//           width: 42px;
//           height: 42px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 10px;

//           color: #ffffff;

//           background: rgba(255,255,255,0.10);

//           font-size: 16px;
//         }

//         .sg-contact-detail strong {
//           display: block;

//           color: #ffffff;

//           font-size: 12px;
//         }

//         .sg-contact-detail span {
//           display: block;

//           margin-top: 4px;

//           color: rgba(255,255,255,0.55);

//           font-size: 10px;

//           line-height: 1.5;
//         }

//         /* =====================================================
//            INFO IMAGE
//         ===================================================== */

//         .sg-contact-image {
//           position: absolute;

//           right: 0;
//           bottom: 0;

//           width: 100%;
//           height: 220px;

//           object-fit: cover;

//           opacity: 0.18;

//           mix-blend-mode: luminosity;

//           pointer-events: none;
//         }

//         /* =====================================================
//            RESPONSE BADGE
//         ===================================================== */

//         .sg-response-badge {
//           position: relative;

//           z-index: 4;

//           display: inline-flex;

//           align-items: center;

//           gap: 9px;

//           margin-top: 35px;

//           padding: 9px 13px;

//           border: 1px solid rgba(255,255,255,0.14);

//           border-radius: 30px;

//           color: rgba(255,255,255,0.82);

//           background: rgba(255,255,255,0.07);

//           font-size: 9px;

//           font-weight: 700;
//         }

//         .sg-response-dot {
//           width: 7px;
//           height: 7px;

//           border-radius: 50%;

//           background: #53d69a;

//           box-shadow:
//             0 0 0 5px rgba(83,214,154,0.10);

//           animation: sgContactPulse 2s infinite;
//         }

//         /* =====================================================
//            FORM
//         ===================================================== */

//         .sg-contact-form-wrapper {
//           padding: 39px;

//           border: 1px solid #dfe8f2;

//           border-radius: 22px;

//           background: #ffffff;

//           box-shadow:
//             0 18px 50px rgba(25, 61, 103, 0.07);

//           opacity: 0;

//           transform: translateX(35px);

//           transition:
//             opacity 0.8s ease 0.12s,
//             transform 0.8s ease 0.12s;
//         }

//         .sg-contact-form-wrapper.visible {
//           opacity: 1;

//           transform: translateX(0);
//         }

//         .sg-form-header {
//           display: flex;

//           align-items: center;

//           justify-content: space-between;

//           gap: 20px;

//           margin-bottom: 27px;

//           padding-bottom: 22px;

//           border-bottom: 1px solid #e8edf3;
//         }

//         .sg-form-title {
//           margin: 0;

//           color: #10213f;

//           font-size: 21px;

//           font-weight: 800;
//         }

//         .sg-form-required {
//           color: #8793a3;

//           font-size: 9px;
//         }

//         /* =====================================================
//            FORM GRID
//         ===================================================== */

//         .sg-form-grid {
//           display: grid;

//           grid-template-columns: 1fr 1fr;

//           gap: 17px;
//         }

//         .sg-form-group {
//           display: flex;

//           flex-direction: column;

//           gap: 7px;
//         }

//         .sg-form-group.full {
//           grid-column: 1 / -1;
//         }

//         .sg-form-label {
//           color: #35455e;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 0.4px;
//         }

//         .sg-form-label span {
//           color: #e56f38;
//         }

//         .sg-form-input,
//         .sg-form-select,
//         .sg-form-textarea {
//           width: 100%;

//           border: 1px solid #dce5ef;

//           border-radius: 8px;

//           background: #fbfdff;

//           color: #243650;

//           font-family: inherit;

//           font-size: 12px;

//           outline: none;

//           transition:
//             border-color 0.2s ease,
//             box-shadow 0.2s ease,
//             background 0.2s ease;
//         }

//         .sg-form-input,
//         .sg-form-select {
//           height: 45px;

//           padding: 0 13px;
//         }

//         .sg-form-textarea {
//           min-height: 100px;

//           padding: 13px;

//           resize: vertical;
//         }

//         .sg-form-input::placeholder,
//         .sg-form-textarea::placeholder {
//           color: #a0aaba;
//         }

//         .sg-form-input:focus,
//         .sg-form-select:focus,
//         .sg-form-textarea:focus {
//           border-color: #7fa9dd;

//           background: #ffffff;

//           box-shadow:
//             0 0 0 3px rgba(21,88,192,0.07);
//         }

//         /* =====================================================
//            DIVISION SELECTOR
//         ===================================================== */

//         .sg-division-selector {
//           display: grid;

//           grid-template-columns:
//             repeat(3, 1fr);

//           gap: 7px;
//         }

//         .sg-division-option {
//           display: flex;

//           align-items: center;

//           gap: 7px;

//           min-height: 37px;

//           padding: 6px 8px;

//           border: 1px solid #e1e8f0;

//           border-radius: 7px;

//           background: #fbfdff;

//           color: #647288;

//           font-size: 8.5px;

//           line-height: 1.3;

//           font-weight: 600;

//           cursor: pointer;

//           transition:
//             border-color 0.2s ease,
//             background 0.2s ease,
//             color 0.2s ease;
//         }

//         .sg-division-option:hover {
//           border-color: #b9cde5;

//           background: #f5f9ff;
//         }

//         .sg-division-option.selected {
//           border-color: #80a9dc;

//           color: #1558c0;

//           background: #edf4ff;
//         }

//         .sg-division-checkbox {
//           width: 14px;
//           height: 14px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border: 1px solid #cbd6e3;

//           border-radius: 3px;

//           color: white;

//           font-size: 8px;

//           font-weight: 900;
//         }

//         .sg-division-option.selected
//         .sg-division-checkbox {
//           border-color: #1558c0;

//           background: #1558c0;
//         }

//         /* =====================================================
//            FILE UPLOAD
//         ===================================================== */

//         .sg-upload {
//           position: relative;

//           display: flex;

//           align-items: center;

//           gap: 13px;

//           min-height: 72px;

//           padding: 13px;

//           border: 1px dashed #b9cce2;

//           border-radius: 9px;

//           background: #f8fbff;

//           cursor: pointer;

//           transition:
//             border-color 0.2s ease,
//             background 0.2s ease;
//         }

//         .sg-upload:hover {
//           border-color: #6e9bd1;

//           background: #f2f7fe;
//         }

//         .sg-upload-icon {
//           width: 42px;
//           height: 42px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 9px;

//           color: #1558c0;

//           background: #eaf2ff;

//           font-size: 17px;
//         }

//         .sg-upload strong {
//           display: block;

//           color: #34445d;

//           font-size: 11px;
//         }

//         .sg-upload span {
//           display: block;

//           margin-top: 4px;

//           color: #8b96a6;

//           font-size: 8.5px;
//         }

//         .sg-upload input {
//           position: absolute;

//           inset: 0;

//           opacity: 0;

//           cursor: pointer;
//         }

//         .sg-upload-files {
//           margin-top: 6px;

//           color: #1558c0;

//           font-size: 9px;

//           font-weight: 700;
//         }

//         /* =====================================================
//            SUBMIT
//         ===================================================== */

//         .sg-submit-row {
//           display: flex;

//           align-items: center;

//           justify-content: space-between;

//           gap: 20px;

//           margin-top: 23px;

//           padding-top: 20px;

//           border-top: 1px solid #e8edf3;
//         }

//         .sg-submit-note {
//           max-width: 300px;

//           color: #8a95a5;

//           font-size: 8.5px;

//           line-height: 1.5;
//         }

//         .sg-submit {
//           min-height: 50px;

//           padding: 0 24px;

//           display: inline-flex;

//           align-items: center;
//           justify-content: center;

//           gap: 9px;

//           flex-shrink: 0;

//           border: none;

//           border-radius: 8px;

//           color: white;

//           background:
//             linear-gradient(
//               135deg,
//               #1558c0,
//               #2874dd
//             );

//           box-shadow:
//             0 11px 25px rgba(21,88,192,0.20);

//           font-family: inherit;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 0.5px;

//           cursor: pointer;

//           transition:
//             transform 0.25s ease,
//             box-shadow 0.25s ease;
//         }

//         .sg-submit:hover {
//           transform: translateY(-2px);

//           box-shadow:
//             0 15px 32px rgba(21,88,192,0.28);
//         }

//         /* =====================================================
//            SUCCESS MESSAGE
//         ===================================================== */

//         .sg-success {
//           display: flex;

//           align-items: center;

//           gap: 10px;

//           margin-bottom: 20px;

//           padding: 12px 14px;

//           border: 1px solid #bde8d3;

//           border-radius: 8px;

//           color: #18724b;

//           background: #effbf5;

//           font-size: 10px;

//           font-weight: 700;
//         }

//         .sg-success-icon {
//           width: 25px;
//           height: 25px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 50%;

//           color: white;

//           background: #2ca66d;

//           font-size: 11px;
//         }

//         /* =====================================================
//            BOTTOM CONTACT FEATURES
//         ===================================================== */

//         .sg-contact-features {
//           display: grid;

//           grid-template-columns:
//             repeat(4, 1fr);

//           gap: 12px;

//           margin-top: 60px;

//           padding-top: 30px;

//           border-top: 1px solid #e3eaf2;
//         }

//         .sg-contact-feature {
//           display: flex;

//           align-items: center;

//           gap: 11px;

//           padding: 7px 10px;
//         }

//         .sg-contact-feature-icon {
//           width: 40px;
//           height: 40px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 10px;

//           color: #1558c0;

//           background: #edf4ff;

//           font-size: 16px;
//         }

//         .sg-contact-feature strong {
//           display: block;

//           color: #1a2c47;

//           font-size: 11px;
//         }

//         .sg-contact-feature span {
//           display: block;

//           margin-top: 3px;

//           color: #8792a2;

//           font-size: 8.5px;
//         }

//         /* =====================================================
//            ANIMATION
//         ===================================================== */

//         @keyframes sgContactPulse {
//           0%,
//           100% {
//             box-shadow:
//               0 0 0 0 rgba(83,214,154,0.20);
//           }

//           50% {
//             box-shadow:
//               0 0 0 7px rgba(83,214,154,0);
//           }
//         }

//         /* =====================================================
//            TABLET
//         ===================================================== */

//         @media (max-width: 1050px) {

//           .sg-contact {
//             padding: 95px 0;
//           }

//           .sg-contact-grid {
//             grid-template-columns:
//               1fr;
//           }

//           .sg-contact-info {
//             min-height: 480px;
//           }

//           .sg-division-selector {
//             grid-template-columns:
//               repeat(3, 1fr);
//           }
//         }

//         /* =====================================================
//            MOBILE
//         ===================================================== */

//         @media (max-width: 760px) {

//           .sg-contact {
//             padding: 80px 0;
//           }

//           .sg-contact-heading {
//             margin-bottom: 45px;
//           }

//           .sg-contact-title {
//             font-size: 39px;

//             letter-spacing: -1.7px;
//           }

//           .sg-contact-intro {
//             font-size: 15px;
//           }

//           .sg-contact-info {
//             padding: 30px;

//             min-height: 460px;
//           }

//           .sg-contact-info-title {
//             font-size: 29px;
//           }

//           .sg-contact-form-wrapper {
//             padding: 27px 20px;
//           }

//           .sg-form-grid {
//             grid-template-columns: 1fr;
//           }

//           .sg-form-group.full {
//             grid-column: auto;
//           }

//           .sg-division-selector {
//             grid-template-columns:
//               1fr 1fr;
//           }

//           .sg-submit-row {
//             display: block;
//           }

//           .sg-submit {
//             width: 100%;

//             margin-top: 15px;
//           }

//           .sg-contact-features {
//             grid-template-columns:
//               1fr 1fr;
//           }
//               .sg-contact-detail-icon svg {
//   width: 17px;
//   height: 17px;
//   stroke-width: 2;
// }
//   .sg-success-icon svg {
//   width: 14px;
//   height: 14px;
//   stroke-width: 2.5;
// }
//   .sg-division-checkbox svg {
//   width: 10px;
//   height: 10px;
//   stroke-width: 2.5;
// }
//   .sg-upload-icon svg {
//   width: 20px;
//   height: 20px;
//   stroke-width: 2;
// }

// .sg-submit-icon {
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .sg-submit-icon svg {
//   width: 16px;
//   height: 16px;
//   stroke-width: 2.5;
// }
//   .sg-contact-feature-icon svg {
//   width: 17px;
//   height: 17px;
//   stroke-width: 2;
// }
//         }

//         /* =====================================================
//            SMALL MOBILE
//         ===================================================== */

//         @media (max-width: 480px) {

//           .sg-contact {
//             padding: 65px 0;
//           }

//           .sg-contact-title {
//             font-size: 35px;
//           }

//           .sg-contact-info {
//             padding: 25px;
//           }

//           .sg-contact-form-wrapper {
//             padding: 23px 17px;
//           }

//           .sg-division-selector {
//             grid-template-columns: 1fr;
//           }

//           .sg-contact-features {
//             grid-template-columns: 1fr;
//           }

//           .sg-contact-feature {
//             padding-left: 0;
//           }
//         }

//       `}</style>


//       <section
//         className="sg-contact"
//         id="contact"
//         ref={sectionRef}
//       >

//         <div className="sg-contact-blueprint"></div>


//         <div className="sg-contact-container">

//           {/* =================================================
//               HEADER
//           ================================================= */}

//           <div
//             className={`sg-contact-heading ${visible ? "visible" : ""
//               }`}
//           >

//             <div className="sg-contact-label">

//               <span className="sg-contact-label-line"></span>

//               Start Your Project

//               <span className="sg-contact-label-line"></span>

//             </div>

//             <h2 className="sg-contact-title">
//               Let's Build Your
//               <br />
//               Estimate <span>Together.</span>
//             </h2>

//             <p className="sg-contact-intro">
//               Have a project coming up? Send us your drawings,
//               project details, and estimating requirements.
//               Our team will review the information and help
//               determine the right estimating support for your
//               project.
//             </p>

//           </div>


//           {/* =================================================
//               CONTACT GRID
//           ================================================= */}

//           <div className="sg-contact-grid">

//             {/* =================================================
//                 LEFT INFORMATION
//             ================================================= */}

//             <div
//               className={`sg-contact-info ${visible ? "visible" : ""
//                 }`}
//             >

//               <div className="sg-contact-info-content">

//                 <div className="sg-contact-info-label">
//                   REQUEST AN ESTIMATE
//                 </div>

//                 <h3 className="sg-contact-info-title">
//                   Have drawings?
//                   <br />
//                   Let's talk numbers.
//                 </h3>

//                 <p className="sg-contact-info-text">
//                   Tell us about your project and what you
//                   need estimated. You can also upload your
//                   drawings, plans, specifications, or other
//                   project documents.
//                 </p>


//                 {/* CONTACT DETAILS */}

//                 <div className="sg-contact-details">

//                   <div className="sg-contact-detail">

//                     <div className="sg-contact-detail-icon">
//                       <FiMail />
//                     </div>

//                     <div>

//                       <strong>
//                         Email
//                       </strong>

//                       <span>
//                         estimates@structguard.co.in
//                       </span>

//                     </div>

//                   </div>


//                   <div className="sg-contact-detail">

//                     <div className="sg-contact-detail-icon">
//                       <FiPhone />
//                     </div>

//                     <div>

//                       <strong>
//                         Phone
//                       </strong>

//                       <span>
//                         +1 (000) 000-0000
//                       </span>

//                     </div>

//                   </div>


//                   <div className="sg-contact-detail">

//                     <div className="sg-contact-detail-icon">
//                       <FiClock />
//                     </div>

//                     <div>

//                       <strong>
//                         Estimating Support
//                       </strong>

//                       <span>
//                         Project-based estimating assistance
//                       </span>

//                     </div>

//                   </div>

//                 </div>


//                 <div className="sg-response-badge">

//                   <span className="sg-response-dot"></span>

//                   Ready to review your project

//                 </div>

//               </div>


//               <img
//                 className="sg-contact-image"
//                 src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=85"
//                 alt=""
//               />

//             </div>


//             {/* =================================================
//                 FORM
//             ================================================= */}

//             <div
//               className={`sg-contact-form-wrapper ${visible ? "visible" : ""
//                 }`}
//             >

//               <div className="sg-form-header">

//                 <h3 className="sg-form-title">
//                   Project Details
//                 </h3>

//                 <span className="sg-form-required">
//                   * Required fields
//                 </span>

//               </div>


//               {/* SUCCESS */}

//               {submitted && (

//                 <div className="sg-success">

//                   <div className="sg-success-icon">
//                     <FiCheckCircle />
//                   </div>

//                   Your estimate request has been
//                   submitted successfully.

//                 </div>

//               )}


//               <form onSubmit={handleSubmit}>

//                 <div className="sg-form-grid">

//                   {/* NAME */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Your Name <span>*</span>
//                     </label>

//                     <input
//                       className="sg-form-input"
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       placeholder="Enter your name"
//                       required
//                     />

//                   </div>


//                   {/* COMPANY */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Company Name
//                     </label>

//                     <input
//                       className="sg-form-input"
//                       type="text"
//                       name="company"
//                       value={formData.company}
//                       onChange={handleChange}
//                       placeholder="Your company"
//                     />

//                   </div>


//                   {/* EMAIL */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Email Address <span>*</span>
//                     </label>

//                     <input
//                       className="sg-form-input"
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       placeholder="you@company.com"
//                       required
//                     />

//                   </div>


//                   {/* PHONE */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Phone Number
//                     </label>

//                     <input
//                       className="sg-form-input"
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       placeholder="+1 (000) 000-0000"
//                     />

//                   </div>


//                   {/* PROJECT TYPE */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Project Type <span>*</span>
//                     </label>

//                     <select
//                       className="sg-form-select"
//                       name="projectType"
//                       value={formData.projectType}
//                       onChange={handleChange}
//                       required
//                     >

//                       <option value="">
//                         Select project type
//                       </option>

//                       {projectTypes.map((type) => (
//                         <option key={type} value={type}>
//                           {type}
//                         </option>
//                       ))}

//                     </select>

//                   </div>


//                   {/* SERVICE */}

//                   <div className="sg-form-group">

//                     <label className="sg-form-label">
//                       Service Required <span>*</span>
//                     </label>

//                     <select
//                       className="sg-form-select"
//                       name="service"
//                       value={formData.service}
//                       onChange={handleChange}
//                       required
//                     >

//                       <option value="">
//                         Select a service
//                       </option>

//                       {services.map((service) => (
//                         <option
//                           key={service}
//                           value={service}
//                         >
//                           {service}
//                         </option>
//                       ))}

//                     </select>

//                   </div>


//                   {/* DIVISIONS */}

//                   <div className="sg-form-group full">

//                     <label className="sg-form-label">
//                       CSI Divisions Required
//                     </label>

//                     <div className="sg-division-selector">

//                       {divisions.map((division) => {

//                         const selected =
//                           formData.divisions.includes(
//                             division
//                           );

//                         return (

//                           <div
//                             key={division}
//                             className={`sg-division-option ${selected
//                               ? "selected"
//                               : ""
//                               }`}
//                             onClick={() =>
//                               handleDivisionChange(
//                                 division
//                               )
//                             }
//                           >

//                             <div className="sg-division-checkbox">

//                               {selected && <FiCheckCircle />}

//                             </div>

//                             {division}

//                           </div>

//                         );

//                       })}

//                     </div>

//                   </div>


//                   {/* FILE UPLOAD */}

//                   <div className="sg-form-group full">

//                     <label className="sg-form-label">
//                       Project Drawings / Documents
//                     </label>

//                     <label className="sg-upload">

//                       <div className="sg-upload-icon">
//                         <FiUploadCloud />
//                       </div>

//                       <div>

//                         <strong>
//                           Upload project files
//                         </strong>

//                         <span>
//                           PDF, DWG, XLSX, DOCX, ZIP
//                         </span>

//                         {formData.files.length > 0 && (

//                           <div className="sg-upload-files">
//                             {formData.files.length} file(s)
//                             selected
//                           </div>

//                         )}

//                       </div>

//                       <input
//                         type="file"
//                         multiple
//                         accept=".pdf,.dwg,.xlsx,.xls,.doc,.docx,.zip"
//                         onChange={handleFileChange}
//                       />

//                     </label>

//                   </div>


//                   {/* MESSAGE */}

//                   <div className="sg-form-group full">

//                     <label className="sg-form-label">
//                       Project Details
//                     </label>

//                     <textarea
//                       className="sg-form-textarea"
//                       name="message"
//                       value={formData.message}
//                       onChange={handleChange}
//                       placeholder="Tell us about your project, deadline, location, scope, or any specific estimating requirements..."
//                     />

//                   </div>

//                 </div>


//                 {/* SUBMIT */}

//                 <div className="sg-submit-row">

//                   <div className="sg-submit-note">
//                     By submitting this form, you agree
//                     to be contacted regarding your project
//                     and estimating requirements.
//                   </div>

//                   <button
//                     type="submit"
//                     className="sg-submit"
//                   >

//                     SEND ESTIMATE REQUEST

//                     <span>
//                       <FiArrowUpRight />
//                     </span>

//                   </button>

//                 </div>

//               </form>

//             </div>

//           </div>


//           {/* =================================================
//               FEATURES
//           ================================================= */}

//           <div className="sg-contact-features">

//             <div className="sg-contact-feature">

//               <div className="sg-contact-feature-icon">
//                 <FiCheckCircle />
//               </div>

//               <div>

//                 <strong>
//                   Detailed Estimates
//                 </strong>

//                 <span>
//                   Organized project cost information
//                 </span>

//               </div>

//             </div>


//             <div className="sg-contact-feature">

//               <div className="sg-contact-feature-icon">
//                 <FiLayers />
//               </div>

//               <div>

//                 <strong>
//                   Quantity Takeoffs
//                 </strong>

//                 <span>
//                   Trade-specific material quantities
//                 </span>

//               </div>

//             </div>


//             <div className="sg-contact-feature">

//               <div className="sg-contact-feature-icon">
//                 <FiGrid />
//               </div>

//               <div>

//                 <strong>
//                   Multi-Division Support
//                 </strong>

//                 <span>
//                   Multiple CSI construction divisions
//                 </span>

//               </div>

//             </div>


//             <div className="sg-contact-feature">

//               <div className="sg-contact-feature-icon">
//                 <FiArrowUpRight />
//               </div>

//               <div>

//                 <strong>
//                   Bid Support
//                 </strong>

//                 <span>
//                   Information built for better bids
//                 </span>

//               </div>

//             </div>

//           </div>

//         </div>

//       </section>
//     </>
//   );
// };

// export default Contact;


import React, { useEffect, useRef, useState } from "react";
import {
  FiMail,
  FiPhone,
  FiClock,
  FiCheckCircle,
  FiUploadCloud,
  FiArrowUpRight,
  FiFileText,
  FiLayers,
  FiGrid,
} from "react-icons/fi";


const Contact = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    projectType: "",
    service: "",
    divisions: [],
    message: "",
    files: [],
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const projectTypes = [
    "Commercial",
    "Residential",
    "Industrial",
    "Institutional",
    "Healthcare",
    "Hospitality",
    "Mixed-Use",
    "Other",
  ];

  const services = [
    "Quantity Takeoffs",
    "Construction Estimating",
    "Pre-Construction Services",
    "BIM Services",
    "Project Engineering",
    "Bid Preparation",
  ];

  const divisions = [
    "01 - General Requirements / GC",
    "02 - Existing Conditions",
    "03 - Concrete",
    "04 - Masonry",
    "05 - Metals",
    "07 - Thermal & Moisture Protection",
    "08 - Openings",
    "09 - Finishes",
    "32 - Exterior Improvements",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleDivisionChange = (division) => {
    setFormData((previous) => {
      const exists = previous.divisions.includes(division);

      return {
        ...previous,
        divisions: exists
          ? previous.divisions.filter(
            (item) => item !== division
          )
          : [...previous.divisions, division],
      };
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    setFormData((previous) => ({
      ...previous,
      files,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Estimate Request:", formData);

    setSubmitted(true);

    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <>
      <style>{`

        /* =====================================================
           CONTACT SECTION
        ===================================================== */

        .sg-contact {
          position: relative;
          overflow: hidden;

          padding: 125px 0;

          background: #ffffff;
        }

        .sg-contact-container {
          position: relative;

          z-index: 2;

          width: min(1380px, 92%);

          margin: auto;
        }

        /* =====================================================
           BLUEPRINT BACKGROUND
        ===================================================== */

        .sg-contact-blueprint {
          position: absolute;

          right: -180px;
          bottom: -100px;

          width: 650px;
          height: 650px;

          opacity: 0.32;

          background-image:
            linear-gradient(
              rgba(25, 88, 175, 0.055) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(25, 88, 175, 0.055) 1px,
              transparent 1px
            );

          background-size: 35px 35px;

          transform: rotate(8deg);

          pointer-events: none;
        }

        /* =====================================================
           HEADER
        ===================================================== */

        .sg-contact-heading {
          max-width: 780px;

          margin: 0 auto 65px;

          text-align: center;

          opacity: 0;

          transform: translateY(30px);

          transition:
            opacity 0.7s ease,
            transform 0.7s ease;
        }

        .sg-contact-heading.visible {
          opacity: 1;

          transform: translateY(0);
        }

        .sg-contact-label {
          display: inline-flex;

          align-items: center;
          justify-content: center;

          gap: 9px;

          color: #175bc3;

          font-size: 12px;

          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-contact-label-line {
          width: 30px;
          height: 2px;

          border-radius: 10px;

          background: #f39818;
        }

        .sg-contact-title {
          margin: 17px 0 18px;

          color: #10213f;

          font-size: clamp(40px, 4.4vw, 63px);

          line-height: 1.03;

          letter-spacing: -2.6px;

          font-weight: 800;
        }

        .sg-contact-title span {
          color: #1b60c8;
        }

        .sg-contact-intro {
          max-width: 650px;

          margin: auto;

          color: #68768a;

          font-size: 16px;

          line-height: 1.75;
        }

        /* =====================================================
           MAIN GRID
        ===================================================== */

        .sg-contact-grid {
          display: grid;

          grid-template-columns:
            0.75fr
            1.25fr;

          gap: 30px;

          align-items: stretch;
        }

        /* =====================================================
           LEFT INFORMATION
        ===================================================== */

        .sg-contact-info {
          position: relative;

          overflow: hidden;

          padding: 38px;

          border-radius: 22px;

          background:
            linear-gradient(
              145deg,
              #102b4d 0%,
              #174f8d 100%
            );

          box-shadow:
            0 25px 60px rgba(16, 48, 84, 0.17);

          opacity: 0;

          transform: translateX(-35px);

          transition:
            opacity 0.8s ease,
            transform 0.8s ease;
        }

        .sg-contact-info.visible {
          opacity: 1;

          transform: translateX(0);
        }

        .sg-contact-info::before {
          content: "";

          position: absolute;

          width: 450px;
          height: 450px;

          right: -230px;
          top: -250px;

          border: 1px solid rgba(255,255,255,0.09);

          border-radius: 50%;
        }

        .sg-contact-info::after {
          content: "";

          position: absolute;

          width: 300px;
          height: 300px;

          right: -130px;
          top: -170px;

          border: 1px dashed rgba(255,255,255,0.08);

          border-radius: 50%;
        }

        .sg-contact-info-content {
          position: relative;

          z-index: 3;
        }

        .sg-contact-info-label {
          color: #f7a62c;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 1.5px;

          text-transform: uppercase;
        }

        .sg-contact-info-title {
          max-width: 430px;

          margin: 12px 0 17px;

          color: #ffffff;

          font-size: 34px;

          line-height: 1.12;

          letter-spacing: -1.2px;

          font-weight: 800;
        }

        .sg-contact-info-text {
          max-width: 430px;

          margin: 0;

          color: rgba(255,255,255,0.65);

          font-size: 12px;

          line-height: 1.75;
        }

        /* =====================================================
           CONTACT DETAILS
        ===================================================== */

        .sg-contact-details {
          margin-top: 40px;
        }

        .sg-contact-detail {
          display: flex;

          align-items: center;

          gap: 13px;

          padding: 17px 0;

          border-bottom: 1px solid rgba(255,255,255,0.10);
        }

        .sg-contact-detail:last-child {
          border-bottom: none;
        }

        .sg-contact-detail-icon {
          width: 42px;
          height: 42px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 10px;

          color: #ffffff;

          background: rgba(255,255,255,0.10);

          font-size: 16px;
        }

        .sg-contact-detail strong {
          display: block;

          color: #ffffff;

          font-size: 12px;
        }

        .sg-contact-detail span {
          display: block;

          margin-top: 4px;

          color: rgba(255,255,255,0.55);

          font-size: 10px;

          line-height: 1.5;
        }

        /* =====================================================
           INFO IMAGE
        ===================================================== */

        .sg-contact-image {
          position: absolute;

          right: 0;
          bottom: 0;

          width: 100%;
          height: 220px;

          object-fit: cover;

          opacity: 0.18;

          mix-blend-mode: luminosity;

          pointer-events: none;
        }

        /* =====================================================
           RESPONSE BADGE
        ===================================================== */

        .sg-response-badge {
          position: relative;

          z-index: 4;

          display: inline-flex;

          align-items: center;

          gap: 9px;

          margin-top: 35px;

          padding: 9px 13px;

          border: 1px solid rgba(255,255,255,0.14);

          border-radius: 30px;

          color: rgba(255,255,255,0.82);

          background: rgba(255,255,255,0.07);

          font-size: 9px;

          font-weight: 700;
        }

        .sg-response-dot {
          width: 7px;
          height: 7px;

          border-radius: 50%;

          background: #53d69a;

          box-shadow:
            0 0 0 5px rgba(83,214,154,0.10);

          animation: sgContactPulse 2s infinite;
        }

        /* =====================================================
           FORM
        ===================================================== */

        .sg-contact-form-wrapper {
          padding: 39px;

          border: 1px solid #dfe8f2;

          border-radius: 22px;

          background: #ffffff;

          box-shadow:
            0 18px 50px rgba(25, 61, 103, 0.07);

          opacity: 0;

          transform: translateX(35px);

          transition:
            opacity 0.8s ease 0.12s,
            transform 0.8s ease 0.12s;
        }

        .sg-contact-form-wrapper.visible {
          opacity: 1;

          transform: translateX(0);
        }

        .sg-form-header {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 20px;

          margin-bottom: 27px;

          padding-bottom: 22px;

          border-bottom: 1px solid #e8edf3;
        }

        .sg-form-title {
          margin: 0;

          color: #10213f;

          font-size: 21px;

          font-weight: 800;
        }

        .sg-form-required {
          color: #8793a3;

          font-size: 9px;
        }

        /* =====================================================
           FORM GRID
        ===================================================== */

        .sg-form-grid {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 17px;
        }

        .sg-form-group {
          display: flex;

          flex-direction: column;

          gap: 7px;
        }

        .sg-form-group.full {
          grid-column: 1 / -1;
        }

        .sg-form-label {
          color: #35455e;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 0.4px;
        }

        .sg-form-label span {
          color: #e56f38;
        }

        .sg-form-input,
        .sg-form-select,
        .sg-form-textarea {
          width: 100%;

          border: 1px solid #dce5ef;

          border-radius: 8px;

          background: #fbfdff;

          color: #243650;

          font-family: inherit;

          font-size: 12px;

          outline: none;

          transition:
            border-color 0.2s ease,
            box-shadow 0.2s ease,
            background 0.2s ease;
        }

        .sg-form-input,
        .sg-form-select {
          height: 45px;

          padding: 0 13px;
        }

        .sg-form-textarea {
          min-height: 100px;

          padding: 13px;

          resize: vertical;
        }

        .sg-form-input::placeholder,
        .sg-form-textarea::placeholder {
          color: #a0aaba;
        }

        .sg-form-input:focus,
        .sg-form-select:focus,
        .sg-form-textarea:focus {
          border-color: #7fa9dd;

          background: #ffffff;

          box-shadow:
            0 0 0 3px rgba(21,88,192,0.07);
        }

        /* =====================================================
           DIVISION SELECTOR
        ===================================================== */

        .sg-division-selector {
          display: grid;

          grid-template-columns:
            repeat(3, 1fr);

          gap: 7px;
        }

        .sg-division-option {
          display: flex;

          align-items: center;

          gap: 7px;

          min-height: 37px;

          padding: 6px 8px;

          border: 1px solid #e1e8f0;

          border-radius: 7px;

          background: #fbfdff;

          color: #647288;

          font-size: 8.5px;

          line-height: 1.3;

          font-weight: 600;

          cursor: pointer;

          transition:
            border-color 0.2s ease,
            background 0.2s ease,
            color 0.2s ease;
        }

        .sg-division-option:hover {
          border-color: #b9cde5;

          background: #f5f9ff;
        }

        .sg-division-option.selected {
          border-color: #80a9dc;

          color: #1558c0;

          background: #edf4ff;
        }

        .sg-division-checkbox {
          width: 14px;
          height: 14px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border: 1px solid #cbd6e3;

          border-radius: 3px;

          color: white;

          font-size: 8px;

          font-weight: 900;
        }

        .sg-division-option.selected
        .sg-division-checkbox {
          border-color: #1558c0;

          background: #1558c0;
        }

        /* =====================================================
           FILE UPLOAD
        ===================================================== */

        .sg-upload {
          position: relative;

          display: flex;

          align-items: center;

          gap: 13px;

          min-height: 72px;

          padding: 13px;

          border: 1px dashed #b9cce2;

          border-radius: 9px;

          background: #f8fbff;

          cursor: pointer;

          transition:
            border-color 0.2s ease,
            background 0.2s ease;
        }

        .sg-upload:hover {
          border-color: #6e9bd1;

          background: #f2f7fe;
        }

        .sg-upload-icon {
          width: 42px;
          height: 42px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 9px;

          color: #1558c0;

          background: #eaf2ff;

          font-size: 17px;
        }

        .sg-upload strong {
          display: block;

          color: #34445d;

          font-size: 11px;
        }

        .sg-upload span {
          display: block;

          margin-top: 4px;

          color: #8b96a6;

          font-size: 8.5px;
        }

        .sg-upload input {
          position: absolute;

          inset: 0;

          opacity: 0;

          cursor: pointer;
        }

        .sg-upload-files {
          margin-top: 6px;

          color: #1558c0;

          font-size: 9px;

          font-weight: 700;
        }

        /* =====================================================
           SUBMIT
        ===================================================== */

        .sg-submit-row {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 20px;

          margin-top: 23px;

          padding-top: 20px;

          border-top: 1px solid #e8edf3;
        }

        .sg-submit-note {
          max-width: 300px;

          color: #8a95a5;

          font-size: 8.5px;

          line-height: 1.5;
        }

        .sg-submit {
          min-height: 50px;

          padding: 0 24px;

          display: inline-flex;

          align-items: center;
          justify-content: center;

          gap: 9px;

          flex-shrink: 0;

          border: none;

          border-radius: 8px;

          color: white;

          background:
            linear-gradient(
              135deg,
              #1558c0,
              #2874dd
            );

          box-shadow:
            0 11px 25px rgba(21,88,192,0.20);

          font-family: inherit;

          font-size: 10px;

          font-weight: 800;

          letter-spacing: 0.5px;

          cursor: pointer;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .sg-submit:hover {
          transform: translateY(-2px);

          box-shadow:
            0 15px 32px rgba(21,88,192,0.28);
        }

        /* =====================================================
           SUCCESS MESSAGE
        ===================================================== */

        .sg-success {
          display: flex;

          align-items: center;

          gap: 10px;

          margin-bottom: 20px;

          padding: 12px 14px;

          border: 1px solid #bde8d3;

          border-radius: 8px;

          color: #18724b;

          background: #effbf5;

          font-size: 10px;

          font-weight: 700;
        }

        .sg-success-icon {
          width: 25px;
          height: 25px;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 50%;

          color: white;

          background: #2ca66d;

          font-size: 11px;
        }

        /* =====================================================
           BOTTOM CONTACT FEATURES
        ===================================================== */

        .sg-contact-features {
          display: grid;

          grid-template-columns:
            repeat(4, 1fr);

          gap: 12px;

          margin-top: 60px;

          padding-top: 30px;

          border-top: 1px solid #e3eaf2;
        }

        .sg-contact-feature {
          display: flex;

          align-items: center;

          gap: 11px;

          padding: 7px 10px;
        }

        .sg-contact-feature-icon {
          width: 40px;
          height: 40px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 10px;

          color: #1558c0;

          background: #edf4ff;

          font-size: 16px;
        }

        .sg-contact-feature strong {
          display: block;

          color: #1a2c47;

          font-size: 11px;
        }

        .sg-contact-feature span {
          display: block;

          margin-top: 3px;

          color: #8792a2;

          font-size: 8.5px;
        }

        /* =====================================================
           ANIMATION
        ===================================================== */

        @keyframes sgContactPulse {
          0%,
          100% {
            box-shadow:
              0 0 0 0 rgba(83,214,154,0.20);
          }

          50% {
            box-shadow:
              0 0 0 7px rgba(83,214,154,0);
          }
        }

        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 1050px) {

          .sg-contact {
            padding: 95px 0;
          }

          .sg-contact-grid {
            grid-template-columns:
              1fr;
          }

          .sg-contact-info {
            min-height: 480px;
          }

          .sg-division-selector {
            grid-template-columns:
              repeat(3, 1fr);
          }
        }

        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 760px) {

          .sg-contact {
            padding: 80px 0;
          }

          .sg-contact-heading {
            margin-bottom: 45px;
          }

          .sg-contact-title {
            font-size: 39px;

            letter-spacing: -1.7px;
          }

          .sg-contact-intro {
            font-size: 15px;
          }

          .sg-contact-info {
            padding: 30px;

            min-height: 460px;
          }

          .sg-contact-info-title {
            font-size: 29px;
          }

          .sg-contact-form-wrapper {
            padding: 27px 20px;
          }

          .sg-form-grid {
            grid-template-columns: 1fr;
          }

          .sg-form-group.full {
            grid-column: auto;
          }

          .sg-division-selector {
            grid-template-columns:
              1fr 1fr;
          }

          .sg-submit-row {
            display: block;
          }

          .sg-submit {
            width: 100%;

            margin-top: 15px;
          }

          .sg-contact-features {
            grid-template-columns:
              1fr 1fr;
          }
              .sg-contact-detail-icon svg {
  width: 17px;
  height: 17px;
  stroke-width: 2;
}
  .sg-success-icon svg {
  width: 14px;
  height: 14px;
  stroke-width: 2.5;
}
  .sg-division-checkbox svg {
  width: 10px;
  height: 10px;
  stroke-width: 2.5;
}
  .sg-upload-icon svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}

.sg-submit-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sg-submit-icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.5;
}
  .sg-contact-feature-icon svg {
  width: 17px;
  height: 17px;
  stroke-width: 2;
}
        }

        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 480px) {

          .sg-contact {
            padding: 65px 0;
          }

          .sg-contact-title {
            font-size: 35px;
          }

          .sg-contact-info {
            padding: 25px;
          }

          .sg-contact-form-wrapper {
            padding: 23px 17px;
          }

          .sg-division-selector {
            grid-template-columns: 1fr;
          }

          .sg-contact-features {
            grid-template-columns: 1fr;
          }

          .sg-contact-feature {
            padding-left: 0;
          }
        }

      `}</style>


      <section
        className="sg-contact"
        id="contact"
        ref={sectionRef}
      >

        <div className="sg-contact-blueprint"></div>


        <div className="sg-contact-container">

          {/* =================================================
              HEADER
          ================================================= */}

          <div
            className={`sg-contact-heading ${visible ? "visible" : ""
              }`}
          >

            <div className="sg-contact-label">

              <span className="sg-contact-label-line"></span>

              Start Your Project

              <span className="sg-contact-label-line"></span>

            </div>

            <h2 className="sg-contact-title">
              Let's Build Your
              <br />
              Estimate <span>Together.</span>
            </h2>

            <p className="sg-contact-intro">
              Have a project coming up? Send us your drawings,
              project details, and service requirements.
              Our team will review the information and help
              determine the right support for your
              project.
            </p>

          </div>


          {/* =================================================
              CONTACT GRID
          ================================================= */}

          <div className="sg-contact-grid">

            {/* =================================================
                LEFT INFORMATION
            ================================================= */}

            <div
              className={`sg-contact-info ${visible ? "visible" : ""
                }`}
            >

              <div className="sg-contact-info-content">

                <div className="sg-contact-info-label">
                  REQUEST A CONSULTATION
                </div>

                <h3 className="sg-contact-info-title">
                  Have drawings or plans?
                  <br />
                  Let's talk numbers.
                </h3>

                <p className="sg-contact-info-text">
                  Tell us about your project and what services
                  you need. You can also upload your
                  drawings, 3D models, specifications, or other
                  project documents.
                </p>


                {/* CONTACT DETAILS */}

                <div className="sg-contact-details">

                  <div className="sg-contact-detail">

                    <div className="sg-contact-detail-icon">
                      <FiMail />
                    </div>

                    <div>

                      <strong>
                        Email
                      </strong>

                      <span>
                        estimates@structguard.co.in
                      </span>

                    </div>

                  </div>


                  <div className="sg-contact-detail">

                    <div className="sg-contact-detail-icon">
                      <FiPhone />
                    </div>

                    <div>

                      <strong>
                        Phone
                      </strong>

                      <span>
                        +1 (000) 000-0000
                      </span>

                    </div>

                  </div>


                  <div className="sg-contact-detail">

                    <div className="sg-contact-detail-icon">
                      <FiClock />
                    </div>

                    <div>

                      <strong>
                        Project Support
                      </strong>

                      <span>
                        Engineering, BIM & Estimating assistance
                      </span>

                    </div>

                  </div>

                </div>


                <div className="sg-response-badge">

                  <span className="sg-response-dot"></span>

                  Ready to review your project

                </div>

              </div>


              <img
                className="sg-contact-image"
                src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=85"
                alt=""
              />

            </div>


            {/* =================================================
                FORM
            ================================================= */}

            <div
              className={`sg-contact-form-wrapper ${visible ? "visible" : ""
                }`}
            >

              <div className="sg-form-header">

                <h3 className="sg-form-title">
                  Project Details
                </h3>

                <span className="sg-form-required">
                  * Required fields
                </span>

              </div>


              {/* SUCCESS */}

              {submitted && (

                <div className="sg-success">

                  <div className="sg-success-icon">
                    <FiCheckCircle />
                  </div>

                  Your project request has been
                  submitted successfully.

                </div>

              )}


              <form onSubmit={handleSubmit}>

                <div className="sg-form-grid">

                  {/* NAME */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Your Name <span>*</span>
                    </label>

                    <input
                      className="sg-form-input"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />

                  </div>


                  {/* COMPANY */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Company Name
                    </label>

                    <input
                      className="sg-form-input"
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Your company"
                    />

                  </div>


                  {/* EMAIL */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Email Address <span>*</span>
                    </label>

                    <input
                      className="sg-form-input"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@company.com"
                      required
                    />

                  </div>


                  {/* PHONE */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Phone Number
                    </label>

                    <input
                      className="sg-form-input"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+1 (000) 000-0000"
                    />

                  </div>


                  {/* PROJECT TYPE */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Project Type <span>*</span>
                    </label>

                    <select
                      className="sg-form-select"
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleChange}
                      required
                    >

                      <option value="">
                        Select project type
                      </option>

                      {projectTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}

                    </select>

                  </div>


                  {/* SERVICE */}

                  <div className="sg-form-group">

                    <label className="sg-form-label">
                      Service Required <span>*</span>
                    </label>

                    <select
                      className="sg-form-select"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >

                      <option value="">
                        Select a service
                      </option>

                      {services.map((service) => (
                        <option
                          key={service}
                          value={service}
                        >
                          {service}
                        </option>
                      ))}

                    </select>

                  </div>


                  {/* DIVISIONS */}

                  <div className="sg-form-group full">

                    <label className="sg-form-label">
                      CSI Divisions Required
                    </label>

                    <div className="sg-division-selector">

                      {divisions.map((division) => {

                        const selected =
                          formData.divisions.includes(
                            division
                          );

                        return (

                          <div
                            key={division}
                            className={`sg-division-option ${selected
                              ? "selected"
                              : ""
                              }`}
                            onClick={() =>
                              handleDivisionChange(
                                division
                              )
                            }
                          >

                            <div className="sg-division-checkbox">

                              {selected && <FiCheckCircle />}

                            </div>

                            {division}

                          </div>

                        );

                      })}

                    </div>

                  </div>


                  {/* FILE UPLOAD */}

                  <div className="sg-form-group full">

                    <label className="sg-form-label">
                      Project Drawings / Documents
                    </label>

                    <label className="sg-upload">

                      <div className="sg-upload-icon">
                        <FiUploadCloud />
                      </div>

                      <div>

                        <strong>
                          Upload project files
                        </strong>

                        <span>
                          PDF, DWG, XLSX, DOCX, ZIP
                        </span>

                        {formData.files.length > 0 && (

                          <div className="sg-upload-files">
                            {formData.files.length} file(s)
                            selected
                          </div>

                        )}

                      </div>

                      <input
                        type="file"
                        multiple
                        accept=".pdf,.dwg,.xlsx,.xls,.doc,.docx,.zip"
                        onChange={handleFileChange}
                      />

                    </label>

                  </div>


                  {/* MESSAGE */}

                  <div className="sg-form-group full">

                    <label className="sg-form-label">
                      Project Details
                    </label>

                    <textarea
                      className="sg-form-textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your project, deadline, location, scope, or any specific requirements..."
                    />

                  </div>

                </div>


                {/* SUBMIT */}

                <div className="sg-submit-row">

                  <div className="sg-submit-note">
                    By submitting this form, you agree
                    to be contacted regarding your project
                    and service requirements.
                  </div>

                  <button
                    type="submit"
                    className="sg-submit"
                  >

                    SEND REQUEST

                    <span>
                      <FiArrowUpRight />
                    </span>

                  </button>

                </div>

              </form>

            </div>

          </div>


          {/* =================================================
              FEATURES
          ================================================= */}

          <div className="sg-contact-features">

            <div className="sg-contact-feature">

              <div className="sg-contact-feature-icon">
                <FiCheckCircle />
              </div>

              <div>

                <strong>
                  Detailed Estimates
                </strong>

                <span>
                  Organized project cost information
                </span>

              </div>

            </div>


            <div className="sg-contact-feature">

              <div className="sg-contact-feature-icon">
                <FiLayers />
              </div>

              <div>

                <strong>
                  Quantity Takeoffs
                </strong>

                <span>
                  Trade-specific material quantities
                </span>

              </div>

            </div>


            <div className="sg-contact-feature">

              <div className="sg-contact-feature-icon">
                <FiGrid />
              </div>

              <div>

                <strong>
                  BIM & Engineering
                </strong>

                <span>
                  Intelligent 3D coordination
                </span>

              </div>

            </div>


            <div className="sg-contact-feature">

              <div className="sg-contact-feature-icon">
                <FiArrowUpRight />
              </div>

              <div>

                <strong>
                  Bid Support
                </strong>

                <span>
                  Information built for better bids
                </span>

              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default Contact;